import { createAsyncThunk } from "@reduxjs/toolkit";
import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";

const loadLoyaltyCustomerTierId = createAsyncThunk(
  "config/loadLoyaltyCustomerTierId",
  async (_, { rejectWithValue }) => {
    try {
      const identitySdk = await sdkProvider("identity");
      const isAuthenticated = await identitySdk.customer.isAuthenticated();
      if (!isAuthenticated) {
        return null;
      }

      const loyaltySdk = await sdkProvider("loyalty");
      const customerTierId = await loyaltySdk.getCustomerTierId();

      return customerTierId;
    } catch (error) {
      if (error.name !== "LoyaltyNotSupportedError") {
        error.message = `loadLoyaltyCustomerTierId failed with error: ${error.message}`;
        logger.error(error);
      }

      return rejectWithValue(error);
    }
  }
);

export default loadLoyaltyCustomerTierId;
